export const contractProductReady = (contract: GQL.IContract) => {
  return (
    contract?.status?.oznaceni === '2 a)' ||
    contract?.status?.oznaceni === '2 b)' ||
    contract?.status?.oznaceni === '2 c)' ||
    contract?.status?.oznaceni === '48 a)' ||
    contract?.status?.oznaceni === '48 b)' ||
    contract?.status?.oznaceni === '48 c)'
  );
};
